export const UP = 'UP' as const;
export const DOWN = 'DOWN' as const;
export const LEFT = 'LEFT' as const;
export const RIGHT = 'RIGHT' as const;

export type CellNavigationDirection = typeof UP | typeof DOWN | typeof LEFT | typeof RIGHT;
export type RowNavigationDirection = typeof UP | typeof DOWN;
